// Englisches Wörterbuch der Self-Service-Fläche. Als `Messages` getippt: fehlt
// ein Schlüssel aus `de.ts`, bricht der Compiler. Ton wie im Deutschen — locker,
// „du" → „you", kurz.
import { saveStatusText } from '@/lib/saveStatusText';
import type { Messages } from './de';

// Self-eigene Übersetzung der Fehlercodes einer Proben-Umbenennung
// (`src/lib/failureReason.ts` bleibt für den Admin deutsch).
function failureReasonEn(error: string): string {
  const m = /^webdav_move_failed_(\d+)$/.exec(error);
  if (m) return `Cloud error (status ${m[1]})`;
  if (error === 'webdav_move_failed_network') return 'Cloud unreachable';
  if (error === 'filename_exists') return 'File name already taken';
  if (error === 'webdav_not_configured') return 'Cloud not configured';
  if (error === 'name_unbuildable') return 'File name could not be created';
  return error;
}

export const en: Messages = {
  langToggleAria: 'Change language',

  invalidLink: 'Invalid link.',
  loading: 'Loading …',

  profileTitle: 'Voice profile',
  loginHint: 'Please enter the password we sent you to manage your details and voice samples.',
  passwordLabel: 'Password',
  loginButton: 'Sign in',
  loginBusy: 'Signing in …',
  loginErrorInvalid: 'Wrong password.',
  loginErrorTooMany: 'Too many attempts, please try again later.',
  loginErrorGeneric: 'Sign-in failed. Please try again later.',

  sectionBasics: 'Basic details',
  ownStudioCheckbox: 'I have my own studio',
  sectionContact: 'Contact',
  sectionLanguages: 'Languages & sound',
  languagesPlaceholder: 'Select languages',
  dialectsPlaceholder: 'Select dialects',
  accentsPlaceholder: 'Select accents',
  lockedBySample: 'used by a voice sample',

  sectionUpload: 'Upload new voice samples',
  dropzone: 'Drag audio files here or click (automatically converted to MP3)',
  removeStaged: 'Remove',
  metaCategory: 'Category',
  metaLanguage: 'Language',
  metaDialect: 'Dialect',
  metaAccent: 'Accent',
  metaFreetext: 'Free text',
  freetextPlaceholder: 'optional',
  demomix: 'DemoMix (compilation)',
  noCategory: 'No category',
  noDialect: 'No dialect',
  noAccent: 'No accent',
  legacyValue: '(legacy value)',

  sectionSamples: 'Your voice samples',
  renameFailuresHeading: (n) => (n === 1
    ? 'One voice sample could not be renamed:'
    : `${n} voice samples could not be renamed:`),
  failureReason: failureReasonEn,
  retry: 'Try again',
  noSamples: 'No voice samples yet.',
  renameHint: 'will be renamed when you save',
  mailHint: "If you'd like a voice sample removed, just send us an email and we'll delete it from the system.",
  requestDeletion: 'Request deletion',

  saveButton: 'Save',
  savingButton: 'Saving …',
  saving: 'Saving …',
  saveStatus: (renameCount) => saveStatusText(renameCount, 'en'),
  convertProgress: (done, total) => `Converting ${done}/${total} …`,
  uploadProgress: (up, total) => `Uploading (${up}/${total}) …`,

  skippedNotAudio: (n) => `${n}× not an audio format`,
  skippedTooLarge: (n) => `${n}× too large (max. 300 MB)`,
  skipped: (parts) => `Skipped: ${parts}.`,
  saved: 'Your changes have been saved.',
  savedWithRenameFailures: (n) => (n === 1
    ? 'Saved, but one voice sample could not be renamed — see list.'
    : `Saved, but ${n} voice samples could not be renamed — see list.`),
  saveFailed: 'Saving failed. Please try again later.',
  merged: (labels) => `Merged: ${labels} updated from TRO.`,
  adoptedFields: (labels) => `New data from TRO applied: ${labels}.`,
  adopted: 'New data from TRO applied.',
  adoptLoadFailed: "Couldn't load new data from TRO. Trying again shortly.",
  keptMine: 'Kept your values, nothing saved.',

  conflictTitle: 'Edited at the same time',
  conflictIntro: 'TRO made changes in the meantime.',
  conflictFields: (labels) => `These fields were changed differently on both sides: ${labels}.`,
  conflictReloadFailed: 'The latest version could not be loaded.',
  conflictRepeated: 'Your profile was changed several times in a row. Please try again.',
  conflictKeepMine: 'Keep my version',
  conflictTakeTheirs: "Use TRO's version",
  conflictOk: 'OK',
};
